/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
	'window',
    'pip-events'
],
function(
    $,
    Mustache,
    pip,
	window,
    pipEvents
){

	return {

		init: function init(){
			$(window.document).off('.navigation').on('click.navigation', '.buybox__discontinued-links a, .product_mainreviews a, #navigationMenu a, .product-title__review-snippet a, #menuScroll a, .smooth-scroll', function(e) {
                $(document).off("scroll.stickyNav-scrollingLinks");
                var parentID = $(this).parent().attr('id');

				if(parentID !== 'BVRRRatingSummaryLinkWriteFirstID' && parentID !== 'BVRRRatingSummaryLinkWriteID' && parentID !== 'BVQASummaryBoxAskFirstQuestionID') {
					e.preventDefault();
				}
				var target = this.hash;

				if(target === "#thdHeader") {
					$('body').velocity('scroll', {
						duration: 1000,
						easing: 'ease-in-out',
                        complete: function () {
                            pipEvents.scroll.scrollAnimationComplete.trigger();
                        }
					});
				} else {
					$(target).velocity('scroll', {
						duration: 1000,
						offset: -110,
						easing: 'ease-in-out',
                        complete: function () {
                            pipEvents.scroll.scrollAnimationComplete.trigger();
                        }
					});
				}
			});

			if (window.location.hash === '#customer_reviews') {
		        window.setTimeout(function() {
					$('a[href="#customer_reviews"]', '#productTabsMenu').click();
		        }, 1500);
		    }
		},
		updateUrl: function updateUrl() {
			if (window.history.replaceState) {
				window.history.replaceState(null, null, pip.products.primary.data.canonicalURL + window.location.search);
			}

			if (!window.location.origin) window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
			$('link[rel="canonical"]').attr('href', window.location.origin  + pip.products.primary.data.canonicalURL);
		},
		updatePageTitle: function updatePageTitle(){
			window.document.title = Mustache.to_html('{{^genericBrandFlag}}{{brandName}}{{/genericBrandFlag}} {{{productLabel}}} - {{modelNumber}} - The Home Depot', pip.products.primary.data.info);
		}

	}

});

}.call(window));